<script setup>
definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

// QUALIVA Phase 2 (lihat docs/cleanup/PHASE-1B-COMPLETION.md): pages/index.vue
// lama adalah landing page marketing publik untuk produk sebelumnya (dihapus Phase
// 1B, seluruh views/front-pages/** ikut terhapus). QUALIVA tidak punya
// halaman marketing publik dalam SPA ini (single-tenant, tanpa self-service
// signup) — root '/' murni gerbang redirect: sudah login -> dashboard,
// belum login -> halaman login. guards.js juga mengarahkan ke '/' setelah
// login berhasil (meta.unauthenticatedOnly), jadi route ini tidak boleh
// dihapus meski tidak punya konten sendiri.
const router = useRouter()
const userData = useCookie('userData')
const accessToken = useCookie('accessToken')

onMounted(() => {
  router.replace(userData.value && accessToken.value ? { name: 'dashboards' } : { name: 'login' })
})
</script>

<template>
  <div />
</template>
